import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import SVG1_1 from '@/components/UI/svg/PowerOcean/App/SVG1_1';
import SVG1_2 from '@/components/UI/svg/PowerOcean/App/SVG1_2';
import SVG1_3 from '@/components/UI/svg/PowerOcean/App/SVG1_3';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('poweroceanapp');

    return (
        <div className={`ef-app-h5-a ${css.efAppH5A}`}>
            <div className="text-wrapper">
                <p className="sub-title">{t('sec1_subtitle')}</p>
                <p className="title">{t('sec1_title')}</p>
                <p className="desc">{t('sec1_desc')}</p>
                <div className="icon-wrapper">
                    <div className="icon">
                        <SVG1_1 width="0.2rem" height="0.18rem" />
                        <p className="text">{t('sec1_icon1')}</p>
                    </div>
                    <div className="icon">
                        <SVG1_2 width="0.2rem" height="0.19rem" />
                        <p className="text">{t('sec1_icon2')}</p>
                    </div>
                    <div className="icon">
                        <SVG1_3 width="0.16rem" height="0.18rem" />
                        <p className="text">{t('sec1_icon3')}</p>
                    </div>
                </div>
            </div>
            <NextImage
                webpSrc={require('@publicLocal/power-ocean/app/kv.webp')}
                src={require('@publicLocal/power-ocean/app/kv.png')}
                alt={t('sec1_title')}
                aria-label={t('sec1_title')}
            />
        </div>
    );
}
